__webpack_require__.p = "https://bmidxbsloveniaplprod.netlify.app/";